import React from 'react';
import config from '../../../utils/config';

function Weekdays() {
  return (
    <div id="main-container" className="main-container nav-effect-1">
      <iframe
        style={{ top: '0px' }}
        id="ouilink-iframe"
        // La query de l'URL est transmise à l'iframe, sinon ?tab=... reste sur la page qui la
        // contient et n'atteint jamais le front v4 (18 autres conteneurs font déjà ce report).
        src={`${config.reportingV4Url}weekdays-details${window.location.search}`}
      />
    </div>
  );
}
export default Weekdays;